//PrevTool.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as PrevTool from "../Menus/PrevTool";
import * as Settings from "../Settings";

import { Button, Icon } from "@mui/material";

import * as React from "react"; //For legacy React components.

export let classRef: PrevTool.Build;

interface iProps {
}
interface iState {
   none: number;
}

export class Build extends React.Component<iProps, iState> {
   toolName: string;

   constructor(props: iProps) {
      super(props);
      this.state = { none: 0 };
   }

   //Refresh this component.
   refresh(toolName: string) {
      this.toolName = toolName;
      this.setState(this.state);
   }

   handleClick() {
      DrawerMenu.prevToolClick(this.toolName);
   }

   render() {
      const styles: Default.iStyles = {
         button: { paddingLeft: 5, paddingRight: 5, borderRadius: 2 },
      };

      if (this.toolName) {
         const ti: Settings.iToolInfo = Settings.getToolInfo(this.toolName);

         if (this.toolName === "Community Information" || this.toolName === "Select on Map") {
            ti.label = this.toolName;
         }

         return (
            <Button style={styles.button} variant="contained" size="medium" color="primary" onClick={this.handleClick.bind(this)} title={ti.tip} >
               <Icon style={{ fontSize: 18, color: ti.iconColorToolbar }}>{ti.iconName}</Icon>
               <span style={{ marginLeft: 4 }}></span>
               {ti.label}
            </Button>
         );

      } else {
         return (<span />);
      }
   } //end render.

   //Component mounted.
   componentDidMount() {
      classRef = this as PrevTool.Build; //Save reference to this component.
   }

} //end build class.
